import * as React from "react"

import { cn } from "@/helpers/classNames"

export type BasicTextareaProps =
  React.TextareaHTMLAttributes<HTMLTextAreaElement>

/**
 * Basic <Textarea> from shadcn/ui,
 * renamed to avoid any confusion with the extising `TextArea` in the `components/core`
 * */
export function BasicTextarea({
  className,
  ref,
  ...props
}: { ref?: React.Ref<HTMLTextAreaElement> } & BasicTextareaProps) {
  return (
    <textarea
      className={cn(
        `
          flex min-h-[80px] w-full rounded-md border border-input px-6 pt-4 pb-2
          ring-offset-background
          placeholder:text-neutral-400
          focus-visible:ring-2 focus-visible:ring-ring
          focus-visible:ring-offset-2 focus-visible:outline-hidden
          disabled:cursor-not-allowed disabled:bg-neutral-200
          disabled:text-neutral-400
        `,
        className,
      )}
      ref={ref}
      {...props}
    />
  )
}
